export default __webpack_public_path__ + "static/grouping-1ff1504f7207178dc7e82ec303161041.jpg";